export const TOUR_PUBLISH = "tour_publish"
export const TOUR_INSPIRE = "tour_inspire"
